import React from 'react';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import IconCoffeeCup from 'components/icons/coffee-cup';
import IconMobileNavLogo from 'components/icons/mobile-nav-home';
import IconRefresh from 'components/icons/refresh-two';
import TimsBarcode from 'components/icons/tims-barcode';
import { useLoyaltyActiveCard } from 'hooks/loyalty';
import { useUIContext } from 'state/ui';
import { routes } from 'utils/routing';

import { NavLink, iconSize } from './helpers';
import More from './more';
import { IconWrap, NavLinkText } from './styled';
import { NavButton } from './styled-link';
import { GetNavLinksParams, NavigationMobileTab } from './types';

const BrandLogo = styled(IconMobileNavLogo)<{ viewBox: string }>`
  height: 30px;
`;

export const getNavLinks = ({
  menuHref,
  formatMessage
}: GetNavLinksParams): NavigationMobileTab[] => {
  return [
    {
      selectedHrefs: [routes.base],
      Component: () => (
        <NavLink data-testid="home-mobile" to={routes.base} requiresExactMatch>
          <IconWrap>
            <BrandLogo viewBox="0 0 24 24" />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: 'home' })}</NavLinkText>
        </NavLink>
      )
    },
    {
      selectedHrefs: [menuHref],
      Component: () => (
        <NavLink data-testid="order-mobile" to={menuHref}>
          <IconWrap>
            <IconCoffeeCup height={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: 'order' })}</NavLinkText>
        </NavLink>
      )
    },
    {
      selectedHrefs: [],
      Component: () => {
        const { showRewardsTab, hideDrawer, isShowingDrawer } = useUIContext();
        const { activeCard } = useLoyaltyActiveCard();
        const navigate = useNavigate();
        const linkText = formatMessage({ id: 'scan' });

        return (
          <NavButton
            className={isShowingDrawer ? 'active' : ''}
            onClick={() => {
              if (!activeCard) {
                return navigate(routes.signIn);
              }
              return isShowingDrawer ? hideDrawer() : showRewardsTab();
            }}
          >
            <IconWrap>
              <TimsBarcode width={iconSize} />
            </IconWrap>
            <NavLinkText>{linkText}</NavLinkText>
          </NavButton>
        );
      }
    },
    {
      selectedHrefs: [routes.orders],
      Component: () => (
        <NavLink data-testid="recent-orders-mobile" to={routes.orders}>
          <IconWrap>
            <IconRefresh width={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: 'recent' })}</NavLinkText>
        </NavLink>
      )
    },
    {
      selectedHrefs: [routes.about],
      Component: () => (
        <NavLink
          data-qa-id="about-mobile"
          data-testid="about-mobile"
          to={routes.about}
          requiresExactMatch
        >
          <IconWrap>
            <More />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: 'more' })}</NavLinkText>
        </NavLink>
      )
    }
  ];
};
